// extracted by mini-css-extract-plugin
export default {"wrapper":"userMenu_wrapper__JUNK0","paragraph":"userMenu_paragraph__o6sHT","btn":"userMenu_btn__j7qhV"};